import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Cart } from '../models/CartModel';
import { Flightinfo } from '../models/flightModel';
import { MypageModel } from '../models/MypageModel';
import { OrderBundleType } from '../models/orderBundle.models';
import { Booking, Order, PaymentReference } from '../models/orderModel';
import { PlannedShuttleBuss, ShuttleBooking } from '../models/ShuttleBookingModel';
import { ReservationModel } from '../models/ShuttleReservationsViewmodel';

@Injectable({
  providedIn: 'root'
})
export class ShuttelbussService {
  private hostPath: string = JSON.parse(environment.IDENTITY);
  public loading = true;
  public ShuttleReservationsModel = new Array<ReservationModel>();
  public ShuttleReservationsModelObservable = new Observable<ReservationModel[]>();
  public ShuttleReservationsModelSubject = new BehaviorSubject<ReservationModel[]>(
    new Array<ReservationModel>()
  );
  public onFormReset = new Subject<void>();
  public MypageModel: MypageModel = new MypageModel(null);
  private MypageModelObservable = new Observable<MypageModel>();
  private MypageModelSubject = new BehaviorSubject<MypageModel>(new MypageModel(null));

  constructor(public router: Router, private authHttp: HttpClient, public dialog: MatDialog) {
    this.MypageModelObservable = this.MypageModelSubject.asObservable();
    this.ShuttleReservationsModelObservable = this.ShuttleReservationsModelSubject.asObservable();
  }

  public resetForm(): void {
    this.onFormReset.next();
  }

  public getOrder(orderId: string): Observable<Order> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/getorder/${orderId}`;
    return this.authHttp.get<Order>(URL).pipe(
      map(order => {
        // console.log(order);
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public createCartOrder(orderId: string): Observable<PaymentReference> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/createcartorder/${orderId}`;
    return this.authHttp.get<PaymentReference>(url).pipe(
      map(paymentReference => {
        console.log('paymentReference', paymentReference);
        return paymentReference;
      }),
      catchError(this.handleError)
    );
  }

  public addOrder(order: Booking): Observable<Cart> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/cart/addorder/';
    return this.authHttp
      .post<Cart>(url, order, { headers })
      .pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public addOrderBundle(order: OrderBundleType): Observable<Cart> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/cart/addorder/';
    return this.authHttp
      .post<Cart>(url, order, { headers })
      .pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public getPlannedOrderShuttleBusType(
    routeCode: string,
    dateFrom: string,
    dateTo: string,
    shuttletypecode: string
  ): Observable<any> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/ordershuttlebus/getplannedordershuttlebustype/${routeCode}/${dateFrom}/${dateTo}/${shuttletypecode}`;
    return this.authHttp.get<PlannedShuttleBuss[]>(url).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getFlights(date: string, type: string): Observable<Flightinfo[]> {
    const model = { site: 'www.shuttlebuss.se', type, date };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/ArrivalDeparture/flightinfo';
    return this.authHttp
      .post<Flightinfo[]>(url, model, { headers })
      .pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public loadMyPageData(): Observable<any> {
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/myPage';
    return this.authHttp.get<any>(url).pipe(
      map((result: any) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public saveMyPageData(model): Observable<any> {
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/myPage';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(url, model, { headers })
      .pipe(
        map((result: any) => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public changePassword(model): Observable<any> {
    const url = this.hostPath + 'identity/user/changepassword';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp.post(url, model, { headers }).pipe(
      map((result: any) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    // Todo: We should use a remote logging infrastructure
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error('shuttlebussService - Handled error: ' + errMsg); // log to console for now
    return observableThrowError(error);
    // Todo: How to handle this properly in component?
  }

  public keyTaskIsDone(organisationId: string, orderLockerId: string): Observable<boolean> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/KeyTaskIsDone/${organisationId}/${orderLockerId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp.post<boolean>(url, {}, { headers }).pipe(
      map((result: any) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public keyIsTaken(organisationId: string, orderLockerId: string): Observable<boolean> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/KeyIsTaken/${organisationId}/${orderLockerId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp.post<boolean>(url, {}, { headers }).pipe(
      map((result: any) => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

}
